import icLinkExternal from 'assets/images/ic-link-external.svg'
import { Button } from 'avo-ui'
import Table from 'components/commons/table'
import { TABLE_ANALYTIC_AWARD } from 'configs/award/configTableAnalyticAward'

export const AnalyticAward = ({ data, query, isLoading, setModal, modal }) => {
    if (!Array.isArray(data)) return

    return (
        <div className={'flex flex-col gap-6'}>
            <div className={'flex gap-x-3'}>
                <Button
                    title={'Export'}
                    icon={icLinkExternal}
                    type={'outline'}
                    onClick={() => setModal({ ...modal, export: true })}
                />
            </div>
            <div className='grid grid-cols-2 gap-6'>
                {data?.map((item, index) => (
                    <div key={index} className='flex flex-col gap-1'>
                        <div className='font-bold uppercase text-center'>{item.name}</div>
                        <Table
                            className={'my-3'}
                            name={item}
                            columns={TABLE_ANALYTIC_AWARD.column}
                            data={item?.votes}
                            size={query?.limit}
                            loading={isLoading}
                        />
                    </div>
                ))}
            </div>
        </div>
    )
}
